import {Component} from 'react'
import { NavLink } from 'reactstrap';
class NavTabMobile extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount(){
        this.CurrentPage()
    }
    CurrentPage(){
        document.getElementById(this.props.page).style.borderBottom =  '3px solid #39296a'
        console.log(document.getElementById(this.props.page).style);
        console.log(this.props.page);
    }
    render() { 
        return (
            <>
             <div className="navTab-mob mob d-block d-md-none">
             <ul className="navTab-mobile-list">

                 <NavLink href="/home"  id="GHURFATY" className="pb-0">
                 <li className="navTab-mob-item">
                     <img className="icon-mob-tab" src="/imgs/navigation-mobile-icons/ghurfati.svg" alt="" />
                 </li>
                 </NavLink>

                 <NavLink href="/vols"  id="VOLS"  className="pb-0">
                 <li className="navTab-mob-item" >
                     <img className="icon-mob-tab s"src="/imgs/navigation-mobile-icons/vols.svg" alt="" />
                 </li>
                 </NavLink>

                 <NavLink href="/voyages"  id="VOYAGES">
                 <li className="navTab-mob-item" > 
                     <img className="icon-mob-tab" src="/imgs/navigation-mobile-icons/voyages.svg" alt="" />
                 </li>
                 </NavLink>

                 <NavLink  href="/cars" id="CARS">
                 <li className="navTab-mob-item">
                     <img className="icon-mob-tab m"  src="/imgs/navigation-mobile-icons/cars.svg" alt="" />
                 </li>
                 </NavLink>

                 <NavLink href="/divertisemment"  id="DIVERTISEMMENT" >
                 <li className="navTab-mob-item">
                     <img className="icon-mob-tab" src="/imgs/navigation-mobile-icons/divertisemment.svg" alt="" />
                 </li>
                 </NavLink>


             </ul>
             </div> 
             <div className="after-search mob">
              <div className="line-after-search d-block d-md-none"></div>
              <div className="title-after-search wh-div-lg d-block d-md-none" style={{width:this.props.width}}><p className="text-after-search bld">{this.props.page}</p></div>
            </div>
             </>
        );
    }
}
 
export default NavTabMobile;